/// <reference types="google.maps" />
import { FullAddress } from '../types/type';

enum InfoType {
  HOUSE_NUMBER = 'street_number',
  STREET = 'route',
  NEIGHBORHOOD = 'neighborhood',
  CITY = 'locality',
  STATE = 'administrative_area_level_1',
  COUNTRY = 'country',
  ZIP = 'postal_code',
}

export function getAddressDetailsByPlaceId(placeId: string): Promise<FullAddress | null> {
  return new Promise((resolve) => {
    try {
      if (typeof google === 'undefined' || !google?.maps?.Geocoder) {
        console.error('Google Maps API has not loaded');
        return resolve(null);
      }

      const geocoder = new google.maps.Geocoder();
      geocoder.geocode(
        { placeId },
        (results: google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatus) => {
          if (status !== google.maps.GeocoderStatus.OK || !results?.[0]) {
            console.error(`Geocoder failed: ${status}`);
            return resolve(null);
          }
          const result = results[0];
          const transformedResponse: FullAddress = {
            houseNumber: mapInformation(result, InfoType.HOUSE_NUMBER),
            streetName: mapInformation(result, InfoType.STREET),
            cityName: mapInformation(result, InfoType.CITY),
            stateName: mapInformation(result, InfoType.STATE),
            countryName: mapInformation(result, InfoType.COUNTRY),
            zipCode: mapInformation(result, InfoType.ZIP),
            latitude: result.geometry.location.lat(),
            longitude: result.geometry.location.lng(),
          };
          resolve(transformedResponse);
        }
      );
    } catch (error) {
      console.error(error);
      resolve(null);
    }
  });
}

function mapInformation(result: google.maps.GeocoderResult, mapType: InfoType): string {
  if (!result?.address_components) {
    return '';
  }

  // Find the address component that contains the requested type
  const component = result.address_components.find((addressComponent) => addressComponent.types.includes(mapType));

  if (!component) {
    return '';
  }

  // STATE uses short_name (e.g., "IL") while others use long_name (e.g., "Illinois")
  return mapType === InfoType.STATE ? component.short_name : component.long_name;
}
